import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { DataExtractionService } from '@/infra/services/data-extraction';
import { queryClient } from '@/store/query';
import { QUERY_KEYS } from '@/utils/query-keys';

interface DeleteDataExtractionsParams {
	ids: string[];
	organization_id: string;
	company_id: string;
}

const Service = DataExtractionService.getInstance();

export const useDeleteDataExtractions = () => {
	return useMutation({
		mutationFn: async (params: DeleteDataExtractionsParams) => Service.deleteDataExtractions(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_DATA_EXTRACTION_LIST]);
			message.success(I18n.get('Extractions deleted successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error deleting extractions'));
		}
	});
};
